import axios from 'axios'
import { Toast, Notify, Dialog } from 'vant'
// import Cookies from 'js-cookie'
import { store } from '../store'
import {
  // CookieSetting,
  SetGetAuthInfo
} from './auth'
import { router } from '@/router'

const instance = axios.create({
  timeout: 0
})
let isShowLoading = false
let loadingToast = null
// add a request interceptor
instance.interceptors.request.use(function (config) {
  isShowLoading = config.loadingConfig && config.loadingConfig.isShow
  const cookieUser = SetGetAuthInfo.getInfo()
  /* 参数上添加上 cookie */
  if (config.params && !config.params.token) {
    config.params.token = store.state.userInfo.token || cookieUser.token || ''
  }
  if (config.data && !config.data.token) {
    config.data.token = store.state.userInfo.token || cookieUser.token || ''
  }
  if (isShowLoading) {
    loadingToast = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: config.loadingConfig.text || '加载中...'
    })
  }

  return config
})

// add a response interceptor
instance.interceptors.response.use(
  function (response) {
    if (isShowLoading) {
      loadingToast.clear()
    }
    console.log(response)
    console.log(response.headers['content-disposition'])
    if (response.headers['content-disposition']) {
      return {
        data: response.data,
        fileName: response.headers['content-disposition'].split('=')[1]
      }
      // return encodeURI(btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')));
    }
    if (response.data.result === 'SUCCESS') {
      return response.data.content
    } if( response.data.code === '200'){
      return response.data.data
    } else {
      if (isShowLoading) {
        loadingToast.clear()
        Notify({ type: 'danger', message: response.data.resultMessage })
      }
      if (response.data.result === 'INVALID_TOKEN') {
        // SetGetAuthInfo.removeInfo()
        // router.push({
        //   path: `/wechat-auth/${encodeURIComponent(
        //     router.currentRoute.fullPath
        //   )}`
        // })
        Dialog.confirm({
          message: 'token无效，重新获取授权信息'
        })
          .then(function () {
            SetGetAuthInfo.removeInfo()
            // SetGetAuthInfo.removeToken()
            // SetGetAuthInfo.removeOpenId()
            // SetGetAuthInfo.removeAvatar()
            // SetGetAuthInfo.removeMobilePhone()
            // SetGetAuthInfo.removeNickName()
            // router
            //   .push({
            //     path: `/wechat-auth/${encodeURIComponent(
            //       router.currentRoute.fullPath
            //     )}`
            //   })
            //   .catch(err => {
            //     err
            //   })
            location.href =
              'auth.html?fromPath=' +
              encodeURIComponent(router.currentRoute.fullPath)
          })
          .catch(() => { })
      }
      return Promise.reject(new Error(response.data.resultMessage))
    }
  },
  function (error) {
    // if (error.message === 'Network Error') {
    //   error.message = '网络错误'
    // }
    if (isShowLoading) {
      loadingToast.clear()
      // Notify({ type: 'danger', message: '投保人数过多，请您稍后再试' })
    }
    return Promise.reject(error)
    // return Promise.reject(new Error('投保人数过多，请您稍后再试'))
  }
)
export const request = instance
